export const formatImportantFlashContent = (content = '') => {
    return String(content)
        .replace(/^(\s*<p[^>]*>\s*)【[^】]*】\s*/i, '$1')
        .replace(/^\s*【[^】]*】\s*/, '')
}
